import MentionElement from './MentionElement.component';

export default MentionElement;